export default "__VITE_ASSET__1Fcsyozi__"